module.exports = __webpack_public_path__ + "img/s2P29.8496f08c.png";